export const locale = {
    lang: 'ar',
    data: {
        BACKGROUND_PANEL_CHOOSE:'غير الخلفية',
    }
};
